import * as Sentry from '@sentry/nextjs'
import camelCase from 'lodash/camelCase'

import Toaster from '../utilities/toaster'

const shouldSendToSentry = (error, path) => {
  // api returns 404 on wrong password
  if (error?.response && error.response.status === 404 && path === 'authorization') return false
  // api returns 400 on duplicate email
  if (error?.response && error.response.status === 400 && path === 'authorization') return false

  return true
}

export const handleError = (path: string = 'general', error: any) => {
  const responseData = error?.response?.data ?? error?.data
  // the schedule endpoints reply { message: 'Error: <code>' } without a `type`, so fall back to the
  // message when it's a bare machine code (human error text stays on the generic default)
  const message = typeof responseData?.message === 'string' ? responseData.message : undefined
  const messageCode = message?.replace(/^Error:\s*/, '')
  const errorToShow = responseData?.type || (messageCode && /^[a-z0-9_]+$/.test(messageCode) ? messageCode : undefined)
  if (errorToShow) {
    Toaster.error(`errors.${path}.${camelCase(errorToShow)}`)
  } else {
    Toaster.error('errors.defaultError')
  }

  if (shouldSendToSentry(error, path)) {
    Sentry.captureException(error, { tags: { path, type: 'handleError' } })
  }
}
